import { Control, Controller, FieldValues } from 'react-hook-form';

import { Input } from './toggleSwitchStyle';

interface IProps {
  value?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  name?: string;
  control?: Control<FieldValues, object>;
}

const ToggleSwitchWithController = ({ defaultChecked, name, id = name, control }: IProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return <Input id={id} type="checkbox" defaultChecked={defaultChecked} {...field} />;
      }}
    />
  );
};

export default ToggleSwitchWithController;
